import nested from "../../assets/nested.webp";
import json from "./nested.json";
import { Project } from "../../components/project";
import { IoIosArrowForward } from "react-icons/io";

export const NestedApp = () => {
  const imageMap = { nested };

  return (
    <div className="flex flex-col sm:items-start items-center text-primary gap-3 animate-fade-down animate-once animate-duration-1000 animate-delay-0 animate-ease-in-out animate-normal animate-fill-both">
      <Project json={json} imageMap={imageMap} />
      <div className="sm:text-[30px] text-[25px] font-[500] mt-3">
        Link to the project
      </div>
      <div className="flex justify-center gap-x-4 text-xl">
        <IoIosArrowForward className="text-secondary mt-1" />
        <a
          rel="noreferrer"
          href={"https://nested-comment-app.netlify.app/"}
          target="_blank"
          className="text-[16px] text-secondary hover:opacity-90"
        >
          Comment Cascade
        </a>
      </div>
    </div>
  );
};
